<div class="dropdown">
  <label
    [for]="id()"
    class="relative flex cursor-pointer items-center">
    <input
      type="checkbox"
      [id]="id()"
      [checked]="isOpen()"
      (change)="isOpen.set($any($event.target).checked)" />

    <ng-content select="label"></ng-content>

    <icon-ui
      name="arrow-circle-right"
      class="text-accent-900 ml-auto block size-4.5 -rotate-90 transition-all" />
  </label>
  <div class="dropdown-content">
    <ng-content select="content"></ng-content>
  </div>
</div>
